<template>
    <v-form ref="formFiltro">
        <v-row no-gutters>
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <v-text-field
                    label="Período Inicial"                
                    v-model="filtro.mesInicial"  
                    :rules="regra.mesInicial"           
                    required
                    outlined
                    dense 
                    type="month"
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <v-text-field
                    label="Período Final"                
                    v-model="filtro.mesFinal"  
                    :rules="regra.mesFinal"           
                    required
                    outlined
                    dense 
                    type="month"
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <v-select
                    label="Visão"
                    :items="listaLocal.visao"
                    v-model="filtro.visao"
                    :rules="regra.visao"
                    :menu-props="menuProps"
                    class="input-cinza"
                    multiple
                    outlined
                    dense
                >
                    <template v-slot:selection="{ item, index }">
                        <span v-if="filtro.visao.length === 1 && index === 0">{{
                            item.text
                        }}</span>
                        <span
                            v-if="filtro.visao.length > 1 && index === 0"
                            class="grey--text caption mr-1"
                            >{{ filtro.visao.length }} selecionados</span
                        >
                    </template>
                </v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <SelectInput
                    label="Filial"
                    v-model="filtro.id_filial"
                    :items="lista.filial"
                    multiple
                    outlined
                    dense
                    show-select-all
                />
            </v-col>      
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <SelectInput
                    label="Bandeira"
                    v-model="filtro.bandeira"
                    :items="lista.bandeira"
                    multiple
                    outlined
                    dense
                    show-select-all
                />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <SelectInput
                    label="Fornecedor"
                    v-model="filtro.id_fornecedor"
                    :items="lista.fornecedor"
                    multiple
                    outlined
                    dense
                    show-select-all
                />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <SelectInput
                    label="Macro Fornecedor"
                    v-model="filtro.id_macrofornecedor"
                    :items="lista.macrofornecedores"
                    multiple
                    outlined
                    dense
                    show-select-all
                />
            </v-col>      
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <SelectInput
                    label="Espaço"
                    v-model="filtro.id_espaco"
                    :items="lista.espaco"
                    multiple
                    outlined
                    dense
                    show-select-all
                />
            </v-col>        
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <SelectInput
                    label="Espaço Macro"
                    v-model="filtro.espaco_macro"
                    :items="lista.espaco_macro"
                    multiple
                    outlined
                    dense
                    show-select-all
                />
            </v-col>      
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <SelectInput
                    label="Cluster"
                    :items="lista.cluster"
                    v-model="filtro.id_cluster"
                    multiple
                    outlined
                    dense
                    show-select-all
                />
            </v-col>    
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <SelectInput
                    label="Categoria"
                    v-model="filtro.categoria"
                    :items="listaCategoria"
                    multiple
                    outlined
                    dense
                    show-select-all
                />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <SelectInput
                    label="Região"
                    v-model="filtro.regiao"
                    :items="lista.regiao"
                    multiple
                    outlined
                    dense
                    show-select-all
                />
            </v-col>    
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <SelectInput
                    label="Perfil"
                    :items="lista.perfil"
                    v-model="filtro.perfil"
                    multiple
                    outlined
                    dense
                    show-select-all
                />
            </v-col>    
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
                <SelectInput
                    label="Tamanho"
                    :items="lista.tamanho"
                    v-model="filtro.tamanho"
                    multiple
                    outlined
                    dense
                    show-select-all
                />
            </v-col> 
            <v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2 ml-auto pb-2" align="end">
                <v-btn
                    class="ml-2 mb-1"
                    color="primary"
                    @click="limpar()"
                >
                    <v-icon left>mdi-filter-off</v-icon> Limpar
                </v-btn> 
                <v-btn
                    class="ml-2 mb-1"
                    color="primary"
                    @click="filtrar()"
                >
                    <v-icon left>mdi-filter</v-icon> Filtrar
                </v-btn>
            </v-col>
        </v-row>
        <v-overlay :value="overlay" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-form>
</template>

<script>
import  useFiltros  from "../../../hooks/useFiltros";

export default {
    setup() {
		const {  isError, isFetching, data: lista, error, refetch } = useFiltros("/gerencial/filtros");

        return {  isError, isFetching, lista, error, refetch };
    },
    data() {
        return {
            menuProps: {
                bottom: true,
                offsetY: true,
                contentClass: 'select-outline',
                transition: 'slide-y-transition',
            },
            listaLocal: {
                visao: [
                    { text: 'PDV', value: 'pdv' },
                    { text: 'Campanha', value: 'campanha' },
                    { text: 'E-commerce', value: 'ecommerce' },
                ],
            },
            filtro: {},
            regra: {
                mesInicial: [
                    v => !!v || 'Selecione um período inicial para o filtro',
                ],            
                mesFinal: [
                    v => !!v || 'Selecione um período final para o filtro',
                    v => (!!v && v >= this.filtro.mesInicial) || 'O período final deve ser igual ou posterior ao período inicial',
                ],  
                visao: [
                    v => Array.isArray(v) && v.length > 0 || 'O campo visão é obrigatório',
                ],
            },   
        }
    },    
    async mounted() {
        console.log('mounted')
        this.iniciaFiltro()

        setTimeout(() => {

            this.filtrar()
        }, 100) 
    },
    computed: {
        overlay(){
            return  Object.keys(this.lista).length === 0 && this.isFetching
        },
        listaCategoria() {
            if (!this.lista || typeof this.lista !== 'object') {
                return []
            }

            return (
                this.lista.categoria ||
                this.lista.categorias ||
                this.lista.categoria_produto ||
                []
            )
        },
    },
    methods: {    
        iniciaFiltro() {
            this.filtro = {
                mesInicial: '',
                mesFinal: '',
                visao: ['pdv', 'campanha', 'ecommerce'],
                bandeira: [],
                id_espaco: [],
                espaco_macro: [],
                id_fornecedor: [],
                id_macrofornecedor: [],
                id_cluster: [],
                categoria: [],
                id_filial: [],
                regiao: [],
                perfil: [],
                tamanho: [],
            }
        },     
        limpar() {

            this.iniciaFiltro()

            this.filtrar()
        },      
        filtrar() {

            if(!this.validate()) return

            this.$emit('filtrar')
        },          
        validate() {
            return this.$refs.formFiltro.validate()
        },
        resetValidation() {
            try {
                this.$refs.formFiltro.resetValidation()
            } catch (error) {
                //console.log(error)
            }   
        },      
    }
}
</script>